import {
  FormControl,
  Grid,
  InputLabel,
  Select,
  Typography,
} from "@mui/material";
import {
  getStudentClassesRequest,
  getStudentScoresExamRequest,
} from "api/requests";
import SingleAreaChart from "components/Charts/SingleAreaChart";
import BackButton from "components/shared/BackButton";
import DrawerCM from "components/shared/Drawer";
import LoadingCM from "components/shared/Loading";
import useHttp from "hooks/use-http";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { useCallback } from "react";
import { Controller, useForm } from "react-hook-form";
import { StyledMenuItem, StyledStack } from "./DisplayScoreChart.style";

export default function ScoreChart() {
  const [studentClasses, setStudentClasses] = useState({
    data: null,
    count: 0,
  });

  const [chartData, setChartData] = useState({
    data: null,
    count: 0,
  });

  const [selectedClass, setSelectedClass] = useState(null);

  const { loading, request } = useHttp();

  const { register, control } = useForm();

  const handleGetScores = (id) => {
    setSelectedClass({ value: id });
    getScores(id);
  };
  const getScores = async (id) => {
    const res = await request({
      url: getStudentScoresExamRequest,
      values: { class_id: id },
    });
    if (!res.count || !res.data.length) {
      return setChartData({
        data: { content: "اطلاعاتی یافت نشد" },
        count: 0,
      });
    } else {
      const transformedData = res.data.map((item) => ({
        id: item.id,
        score: item?.percentage ?? 0,
        // date: item.score_model.date.string ?? "ثبت نشده",
        date:
          item.exam_model.date.jdate.split(" ")[0].split("-").join("/") ??
          "ثبت نشده",
      }));
      const obj = {
        id: 0,
        score: "",
        date: "",
      };
      transformedData.unshift(obj);
      setChartData({
        data: transformedData,
        count: res.count,
      });
    }
  };
  const getClasses = useCallback(async () => {
    const { data: res } = await request({
      url: getStudentClassesRequest,
    });
    if (res.count || res.data.length) {
      const transformedData = res.data.map((item) => ({
        id: item.id,
        name: item.title,
      }));

      setStudentClasses({
        data: transformedData,
        count: res.count,
      });
    }
  }, []);

  useEffect(() => {
    getClasses();
  }, []);
  return (
    <DrawerCM title=" نمودار نمرات آزمون " $styledHeader>
      <Grid item xs={12} my={3}>
        <BackButton />
      </Grid>
      {loading ? (
        <LoadingCM />
      ) : (
        <>
          <StyledStack>
            <Grid container>
              <Grid item sm={5} xs={12} p={0.5}>
                <Controller
                  name="student_class"
                  control={control}
                  defaultValue={""}
                  render={() => (
                    <FormControl fullWidth size="small">
                      <InputLabel id="student_class">انتخاب کلاس</InputLabel>
                      <Select
                        id="student_class"
                        name="student_class"
                        label="انتخاب کلاس"
                        labelId="select-student_class"
                        value={selectedClass?.value || ""}
                        {...register("student_class")}
                        onChange={(e) => handleGetScores(e.target.value)}
                      >
                        {studentClasses.count &&
                          studentClasses?.data?.map((item, index) => {
                            return (
                              <StyledMenuItem key={index} value={item.id}>
                                {item.name}
                              </StyledMenuItem>
                            );
                          })}
                      </Select>
                    </FormControl>
                  )}
                />
              </Grid>
            </Grid>
          </StyledStack>
          {chartData.count ? (
            <StyledStack>
              <SingleAreaChart
                data={chartData.data}
                keyX="date"
                keyY={"score"}
              />
            </StyledStack>
          ) : chartData?.data?.content ? (
            <Typography my={3}>{chartData.data.content}</Typography>
          ) : (
            <Typography my={3}>کلاسی انتخاب نشده است</Typography>
          )}
        </>
      )}
    </DrawerCM>
  );
}
